interface PriceProps {
  readonly amount: number | null
  readonly currency?: string
  readonly compareAt?: number | null
  readonly size?: 'sm' | 'md' | 'lg'
  readonly className?: string
}

const SIZE: Record<NonNullable<PriceProps['size']>, string> = {
  sm: 'text-body-sm',
  md: 'text-body-lg',
  lg: 'text-h3'
}

const CURRENCY_SYMBOL: Record<string, string> = {
  INR: '₹',
  USD: '$',
  AED: 'د.إ ',
  GBP: '£',
  SGD: 'S$'
}

function format(amount: number, currency: string): string {
  const symbol = CURRENCY_SYMBOL[currency] ?? currency + ' '
  // Indian thousands separator: 1,23,456 — but Intl.NumberFormat handles this.
  const formatted = new Intl.NumberFormat(currency === 'INR' ? 'en-IN' : 'en-US', {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0
  }).format(amount)
  return `${symbol}${formatted}`
}

export function Price({
  amount,
  currency = 'INR',
  compareAt,
  size = 'md',
  className = ''
}: PriceProps): JSX.Element {
  if (amount === null) {
    return (
      <span className={`font-heading font-medium text-text-secondary italic ${SIZE[size]} ${className}`}>
        Price coming soon
      </span>
    )
  }
  return (
    <span className={`inline-flex items-baseline gap-2 ${className}`}>
      <span className={`font-heading font-semibold text-charcoal ${SIZE[size]}`}>
        {format(amount, currency)}
      </span>
      {compareAt !== undefined && compareAt !== null && compareAt > amount ? (
        <span className="font-body text-body-sm text-text-secondary line-through">
          {format(compareAt, currency)}
        </span>
      ) : null}
    </span>
  )
}
